import React from 'react';
import { BsPencilSquare, BsTrash } from 'react-icons/bs';

import { hideModal, showModal } from '../../../../../../../../../../redux/modules/modal';
import { showTray } from '../../../../../../../../../../redux/modules/tray';
import ConfirmActionWarningModal from '../../../../../../../../../ConfirmActionWarningModal';
import StackedButtonGroup from '../../../../../../../../../Modal/ModalButtonGroups/StackedButtonGroup';

import EditQuestionCategoryNameModal from './EditQuestionCategoryNameModal';
import EditQuestionModal from './EditQuestionModal';

export const customQuestionOptions = (question, editQuestion, deleteQuestion) => [
  {
    label: 'Edit Custom Question',
    id: 'edit',
    icon: BsPencilSquare,
    handler: ({ e, dispatch }) => {
      e.stopPropagation();
      e.preventDefault();

      dispatch(showModal(
        () => <EditQuestionModal editQuestion={editQuestion} question={question} />,
        { size: 'xl' }
      ));
    }
  },
  {
    label: 'Delete Custom Question',
    id: 'delete',
    icon: BsTrash,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const questionId = e.currentTarget.value;

      const description = 'This will remove the selected question from the list of questions in the requirements builder.  Record\'s with this question in its requirements will not be impacted';

      dispatch(showModal(
        () => <ConfirmActionWarningModal description={description} />,
        {
          title: 'Delete Question?',
          size: 'md',
          buttons: {
            component: StackedButtonGroup,
            primaryButtonOptions: {
              label: 'Delete',
              isDisabled: true,
              onClick: () => {
                deleteQuestion({ questionId });
                dispatch(hideModal());
              }
            }
          }
        }
      ));
    }
  }
];

export const customQuestionCategoryOptions = (questionCategory, editCategory, deleteCategory) => [
  {
    label: 'Edit Category Name',
    id: 'edit',
    icon: BsPencilSquare,
    handler: ({ e, dispatch }) => {
      e.stopPropagation();
      e.preventDefault();

      dispatch(showModal(
        () => <EditQuestionCategoryNameModal editCategory={editCategory} questionCategory={questionCategory} />
      ));
    }
  },
  {
    label: 'Delete Category',
    id: 'delete',
    icon: BsTrash,
    handler: ({ e, dispatch, blueprint }) => {
      e.stopPropagation();
      e.preventDefault();

      const questionCategoryId = e.currentTarget.value;

      const description = 'This will delete all the questions within the category.  Existing records that have questions from this category in its requirements will not be impacted.';

      dispatch(showModal(
        () => <ConfirmActionWarningModal description={description} />,
        {
          title: 'Delete Question Category?',
          size: 'md',
          buttons: {
            component: StackedButtonGroup,
            primaryButtonOptions: {
              label: 'Delete',
              isDisabled: true,
              onClick: async () => {
                await deleteCategory({ questionCategoryId });
                dispatch(hideModal());
              }
            }
          }
        }
      ));
    }
  }
];
